/**
 * CONSTANT常量管理
 */
const CONSTANT = {
	/**
	 * GOODS_TYPE 商品类型
	 * EQUIPMENT 整机 PART 配件 SERVE 服务
	 */
	GOODS_TYPE: {
		EQUIPMENT: 1,
		PART: 2,
		SERVE: 3
	}
}

export {CONSTANT}